import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { User, UserTree, UserPasswordChange, AccountDeletionInfo } from '../models/user.model';
import { RFCMessage } from '../models/common.model';

@Injectable()
export class UserService {


    constructor(private httpClient: HttpClient) { }


    getCurrentUser() {
        return this.httpClient.get<User>(environment.backendUrl + '/user/me', {});
    }

    updateUserNames(data: User) {
        return this.httpClient.patch<RFCMessage>(environment.backendUrl + '/user/me/names', { data });
    }

    /** Preferencje konta - na razie jedna: podpowiedź płci imienia z AI. */
    updatePreferences(data: { ai_name_sex: boolean }) {
        return this.httpClient.patch<RFCMessage>(environment.backendUrl + '/user/me/preferences', { data });
    }

    updatePassword(data: UserPasswordChange) {
        return this.httpClient.patch<RFCMessage>(environment.backendUrl + '/user/me/password', { data });
    }

    getUserTrees() {
        return this.httpClient.get<UserTree[]>(environment.backendUrl + '/user/tree');
    }

    setTreeDefault(tree: number) {
        return this.httpClient.post(environment.backendUrl + '/user/tree/'+tree+'/default/set', {});
    }

    removeTreeDefault(tree: number) {
        return this.httpClient.post(environment.backendUrl + '/user/tree/'+tree+'/default/remove', {});
    }

    /** Co zniknie razem z kontem - pokazywane przed potwierdzeniem usunięcia */
    getAccountDeletionInfo() {
        return this.httpClient.get<AccountDeletionInfo>(environment.backendUrl + '/user/me/deletion-info');
    }

    /** Trwałe usunięcie konta; potwierdzeniem jest wpisana nazwa użytkownika */
    deleteAccount(username: string) {
        return this.httpClient.request<{ result: string }>(
            'delete', environment.backendUrl + '/user/me', { body: { data: { username } } }
        );
    }

}
